import {
  LIST_DEPARTMENT_REQUEST,
  LIST_DEPARTMENT_SUCCESS,
  LIST_DEPARTMENT_FAIL,
  LIST_DEPARTMENT_SUMMARY_REQUEST,
  LIST_DEPARTMENT_SUMMARY_SUCCESS,
  LIST_DEPARTMENT_SUMMARY_FAIL,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAIL,
  DETAIL_DEPARTMENT_REQUEST,
  DETAIL_DEPARTMENT_SUCCESS,
  DETAIL_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  RESET_DEPARTMENT
} from '../../constants/departments'

const initialState = {
  loading: false,
  departments: [],
  departmentsSummary: [],
  department: {},
  error: null,
  pageable: {}
}

const listDepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_DEPARTMENT_REQUEST:
      return { ...state, loading: true }
    case LIST_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, departments: action.payload, pageable: action.pageable }
    case LIST_DEPARTMENT_FAIL:
      return { ...state, loading: false, error: action.payload, departments: [] }
    case LIST_DEPARTMENT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_DEPARTMENT_SUMMARY_SUCCESS:
      return { ...state, loading: false, departmentsSummary: action.payload }
    case LIST_DEPARTMENT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_DEPARTMENT_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_DEPARTMENT_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_DEPARTMENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_DEPARTMENT_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_DEPARTMENT_SUCCESS:
      return { ...state, loadingDetail: false, department: action.payload }
    case DETAIL_DEPARTMENT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_DEPARTMENT_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_DEPARTMENT_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_DEPARTMENT_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_DEPARTMENT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_DEPARTMENT_SUCCESS:
      const departmentIdDelete = action.payload
      const departmentsDelete = [...state.departments]

      const indexDelete = departmentsDelete.findIndex(department => department.id === departmentIdDelete)
      departmentsDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, departments: departmentsDelete }
    case DELETE_DEPARTMENT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_DEPARTMENT:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listDepartmentReducer
